export default __webpack_public_path__ + "static/media/pix_semfundo.3f52d6d6.png";